
export const PERMISSIONS = {
    // Task Permissions
    CAN_ADD_TASK: 'CanAddTask',
    CAN_VIEW_TASK: 'CanViewTask',
    CAN_UPDATE_TASK: 'CanUpdateTask',
    CAN_DELETE_TASK: 'CanDeleteTask',
  
    // Employee Permissions
    CAN_ADD_EMPLOYEE: 'CanAddEmployee',
    CAN_UPDATE_EMPLOYEE: 'CanUpdateEmployee',
    CAN_DELETE_EMPLOYEE: 'CanDeleteEmployee',
    CAN_VIEW_EMPLOYEE: 'CanViewEmployee',
  
    // Office Location Permissions
    CAN_ADD_OFFICE_LOCATION: 'CanAddOfficeLocation',
    CAN_UPDATE_OFFICE_LOCATION: 'CanUpdateOfficeLocation',
    CAN_DELETE_OFFICE_LOCATION: 'CanDeleteOfficeLocation',
    CAN_VIEW_OFFICE_LOCATION: 'CanViewOfficeLocation',
  
    // Product Permissions
    CAN_ADD_PRODUCT: 'CanAddProduct',
    CAN_UPDATE_PRODUCT: 'CanUpdateProduct',
    CAN_DELETE_PRODUCT: 'CanDeleteProduct',
    CAN_VIEW_PRODUCT: 'CanViewProduct',
  
    // Permission Permissions
    CAN_ADD_PERMISSION: 'CanAddPermission',
    CAN_UPDATE_PERMISSION: 'CanUpdatePermission',
    CAN_DELETE_PERMISSION: 'CanDeletePermission',
    CAN_VIEW_PERMISSION: 'CanViewPermission',
  
    // Invoice Permissions
    CAN_GENERATE_INVOICE: 'CanGenerateInvoice',
    CAN_UPDATE_INVOICE: 'CanUpdateInvoice',
  
    // Role Permissions
    CAN_VIEW_ROLE: 'CanViewRole',
    CAN_ADD_ROLE: 'CanAddRole',
    CAN_UPDATE_ROLE: 'CanUpdateRole',
  
    // Designation Permissions
    CAN_VIEW_DESIGNATION: 'CanViewDesignation',
    CAN_ADD_DESIGNATION: 'CanAddDesignation',
    CAN_UPDATE_DESIGNATION: 'CanUpdateDesignation',
  
    // Department Permissions
    CAN_VIEW_DEPARTMENT: 'CanViewDepartment',
    CAN_ADD_DEPARTMENT: 'CanAddDepartment',
    CAN_UPDATE_DEPARTMENT: 'CanUpdateDepartment',
  
    // Team Permissions
    CAN_VIEW_TEAM: 'CanViewTeam',
    CAN_ADD_TEAM: 'CanAddTeam',
    CAN_UPDATE_TEAM: 'CanUpdateTeam',
    CAN_DELETE_TEAM: 'CanDeleteTeam',
  
    // Employment Status Permissions
    CAN_VIEW_EMPLOYMENT_STATUS: 'CanViewEmploymentStatus',
    CAN_ADD_EMPLOYMENT_STATUS: 'CanAddEmploymentStatus',
    CAN_UPDATE_EMPLOYMENT_STATUS: 'CanUpdateEmploymentStatus',
    CAN_DELETE_EMPLOYMENT_STATUS: 'CanDeleteEmploymentStatus',
  
    // City/Country Permissions
    CAN_VIEW_CITY: 'CanViewCity',
    CAN_ADD_CITY: 'CanAddCity',
    CAN_UPDATE_CITY: 'CanUpdateCity',
    CAN_DELETE_CITY: 'CanDeleteCity',
    CAN_VIEW_COUNTRY: 'CanViewCountry',
    CAN_ADD_COUNTRY: 'CanAddCountry',
    CAN_UPDATE_COUNTRY: 'CanUpdateCountry',
    CAN_DELETE_COUNTRY: 'CanDeleteCountry',
  
    // Doctor Permissions
    CAN_VIEW_DOCTOR: 'CanViewDoctor',
    CAN_ADD_DOCTOR: 'CanAddDoctor',
    CAN_UPDATE_DOCTOR: 'CanUpdateDoctor',
    CAN_DELETE_DOCTOR: 'CanDeleteDoctor',
  
    // Gender Permissions
    CAN_VIEW_GENDER: 'CanViewGender',
    CAN_ADD_GENDER: 'CanAddGender',
    CAN_UPDATE_GENDER: 'CanUpdateGender',
    CAN_DELETE_GENDER: 'CanDeleteGender',
  
    // Practice Location Permissions
    CAN_VIEW_PRACTICE_LOCATION: 'CanViewPracticeLocation',
    CAN_ADD_PRACTICE_LOCATION: 'CanAddPracticeLocation',
    CAN_UPDATE_PRACTICE_LOCATION: 'CanUpdatePracticeLocation',
    CAN_DELETE_PRACTICE_LOCATION: 'CanDeletePracticeLocation',
  
    // Designation Level Permissions
    CAN_VIEW_DESIGNATION_LEVEL: 'CanViewDesignationLevel',
    CAN_ADD_DESIGNATION_LEVEL: 'CanAddDesignationLevel',
    CAN_UPDATE_DESIGNATION_LEVEL: 'CanUpdateDesignationLevel',
  
    // Subtask Permissions
    CAN_ADD_SUBTASK: 'CanAddSubTask',
    CAN_VIEW_SUBTASK: 'CanViewSubTask',
    CAN_UPDATE_SUBTASK: 'CanUpdateSubTask',
    CAN_DELETE_SUBTASK: 'CanDeleteSubTask',
  
    // Task Priority Permissions
    CAN_VIEW_TASK_PRIORITY: 'CanViewTaskPriority',
    CAN_ADD_TASK_PRIORITY: 'CanAddTaskPriority',
    CAN_UPDATE_TASK_PRIORITY: 'CanUpdateTaskPriority',
    CAN_DELETE_TASK_PRIORITY: 'CanDeleteTaskPriority',
  
    // Report Permissions
    CAN_VIEW_REPORT: 'CanViewReport',
  
    // Plan Permissions
    CAN_ADD_PLAN: 'CanAddPlan',
    CAN_DELETE_PLAN: 'CanDeletePlan',
    CAN_UPDATE_PLAN: 'CanUpdatePlan',
    CAN_APPROVE_PLAN: 'CanApprovePlan',
    CAN_REJECT_PLAN: 'CanRejectPlan',
    CAN_VIEW_PLAN: 'CanViewPlan',
  
    // Visit Profile Permissions
    CAN_ADD_VISIT_PROFILE: 'CanAddVisitProfile',
    CAN_VIEW_VISIT_PROFILE: 'CanViewVisitProfile',
    CAN_UPDATE_VISIT_PROFILE: 'CanUpdateVisitProfile',
    CAN_DELETE_VISIT_PROFILE: 'CanDeleteVisitProfile',
  
    // Hierarchy Permissions
    CAN_VIEW_HIERARCHY: 'CanViewHierarchy',
  
    // Task Note Permissions
    CAN_VIEW_TASK_NOTE: 'CanViewTaskNote',
    CAN_ADD_TASK_NOTE: 'CanAddTaskNote',
    CAN_UPDATE_TASK_NOTE: 'CanUpdateTaskNote',
    CAN_DELETE_TASK_NOTE: 'CanDeleteTaskNote',
  
    // Customer Rank Permissions
    CAN_VIEW_CUSTOMER_RANK: 'CanViewCustomerRank',
    CAN_ADD_CUSTOMER_RANK: 'CanAddCustomerRank',
    CAN_UPDATE_CUSTOMER_RANK: 'CanUpdateCustomerRank',
    CAN_DELETE_CUSTOMER_RANK: 'CanDeleteCustomerRank',
  
    // Task Target Permissions
    CAN_VIEW_TASK_TARGET: 'CanViewTaskTarget',
  
    // Subordinate Permissions
    CAN_VIEW_SUBORDINATE: 'CanViewSubOrdinate',
  
    // Logs Permissions
    CAN_VIEW_LOGS: 'CanViewLogs',
  
    // Stats Permissions
    CAN_VIEW_STATS: 'CanViewStats',
  
    // Planner Permissions
    CAN_ADD_PLAN_TASK: 'CanAddPlanTask',
    CAN_UPDATE_PLAN_TASK: 'CanUpdatePlanTask',
    CAN_VIEW_PLAN_TASK: 'CanViewPlanTask',
    CAN_ADD_PLANNER_TIME: 'CanAddPlannerTime',
    CAN_ADD_PLANNER_LOCATION: 'CanAddPlannerLocation',
    CAN_ADD_PLANNER_DOCTOR: 'CanAddPlannerDoctor',
    CAN_ADD_PLANNER_CITY: 'CanAddPlannerCity',
  
    // Form Permissions
    CAN_VIEW_FORM: 'CanViewForm',
    CAN_ADD_FORM: 'CanAddForm',
    CAN_DELETE_FORM: 'CanDeleteForm',
    CAN_UPDATE_FORM: 'CanUpdateForm',
  
    // Archived Task Permissions
    CAN_VIEW_ARCHIVED_TASK: 'CanViewArchivedTask',
    CAN_ADD_ARCHIVED_TASK: 'CanAddArchivedTask',
    CAN_UPDATE_ARCHIVED_TASK: 'CanUpdateArchivedTask',
    CAN_DELETE_ARCHIVED_TASK: 'CanDeleteArchivedTask',
  
    CAN_VIEW_MANAGE: 'CanViewManage',
  };
  